<template>
  <div
    class="image-container-fail flex flex-col justify-center items-center w-full h-full"
  >
    <feather-icon
      class="image-read-error-icon"
      icon="AlertCircleIcon"
    ></feather-icon>
    <div class="image-read-error-message">
      {{ imageReadErrorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: "OperationReportShowBodyFormItemImageReadErrorMessage",

  props: {
    imageReadErrorMessage: {
      type: String,
      default: "",
    },
  },
};
</script>
